import { render, staticRenderFns } from "./block-pagination.vue?vue&type=template&id=5a1db002&scoped=true"
import script from "./block-pagination.vue?vue&type=script&lang=js"
export * from "./block-pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1db002",
  null
  
)

export default component.exports